import { DirectiveOptions } from 'vue';

const selectOnTab: DirectiveOptions = {

    inserted: function (el) {
        
        // Workaround to force 'tab' keypress to behave like 'enter'
        // We have to hunt for the actual input element and listen for key presses on that
        $(el).find(".multiselect__input").keydown(function (event) {
            if (event.which === 9 && $(event.target).val()) {   // if event is tab and some text was entered
                var e = $.Event('click'); // create click event
                $(event.target).parent().siblings().find('.multiselect__option--highlight:not(.multiselect__option--selected)').trigger(e); // trigger click event to select the focused option
                event.preventDefault(); // prevent tab default action, this keeps the cursor in the input
            }
        });

    }
};

export default selectOnTab;